'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind from "./presto.types$-Rule-Kind.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleKind$$anon$106(_$ordinal$30, \u03b4name$30, outer) {
  this.cyf = 0;
  this.a9N = null;
  this.cyf = _$ordinal$30;
  this.a9N = \u03b4name$30;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$RuleKind$$anon$106 as $c_Lpresto_types$RuleKind$$anon$106 };
$p = $c_Lpresto_types$RuleKind$$anon$106.prototype = new $j_presto$002etypes$0024$002dRule$002dKind.$h_Lpresto_types$RuleKind();
$p.constructor = $c_Lpresto_types$RuleKind$$anon$106;
/** @constructor */
function $h_Lpresto_types$RuleKind$$anon$106() {
}
export { $h_Lpresto_types$RuleKind$$anon$106 as $h_Lpresto_types$RuleKind$$anon$106 };
$h_Lpresto_types$RuleKind$$anon$106.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9N;
});
$p.l = (function() {
  return this.a9N;
});
var $d_Lpresto_types$RuleKind$$anon$106 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleKind$$anon$106, "presto.types$RuleKind$$anon$106", ({
  a1k: 1,
  a1i: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$RuleKind$$anon$106 as $d_Lpresto_types$RuleKind$$anon$106 };
//# sourceMappingURL=presto.types$-Rule-Kind$$anon$106.js.map
